import { useCallback, useEffect, useRef } from "react";

import { create } from "zustand";

const hoverTextKeys = {
  noHover: "noHover",
  email: "email",
  text: "text",
  addMember: "addMember",
  superSearch: "superSearch",
};

const useToolbarStore = create((set) => ({
  hoverTextKey: hoverTextKeys.noHover,
  setHoverTextKey: (newText) => set({ hoverTextKey: newText }),
  timeoutRef: undefined,
  setTimeoutRef: (newRef) => set({ timeoutRef: newRef }),
}));

const useTimeoutRef = () => {
  const timeoutRef = useToolbarStore((s) => s.timeoutRef);
  const setTimeoutRef = useToolbarStore((s) => s.setTimeoutRef);
  const ref = useRef();

  useEffect(() => {
    setTimeoutRef(ref);
  }, [setTimeoutRef]);

  return [timeoutRef, setTimeoutRef];
};

const useHoverTextKey = () => {
  const hoverTextKey = useToolbarStore((s) => s.hoverTextKey);
  const setHoverTextKeyRaw = useToolbarStore((s) => s.setHoverTextKey);
  const [timeoutRef = {}] = useTimeoutRef();

  const setHoverTextKey = useCallback(
    (newKey) => {
      clearTimeout(timeoutRef.current);
      if (newKey === hoverTextKeys.noHover) {
        timeoutRef.current = setTimeout(() => {
          setHoverTextKeyRaw(newKey);
        }, 150);
      } else setHoverTextKeyRaw(newKey);
    },
    [setHoverTextKeyRaw, timeoutRef]
  );

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, [timeoutRef]);

  return [hoverTextKey, setHoverTextKey];
};

export { useHoverTextKey, hoverTextKeys };
export default useToolbarStore;
